const COMPONENT_PREFIX_PATTERN =
  /^[A-Za-z][A-Za-z0-9/_(). -]{0,80}(?:\s-\s\d+)?\s*:\s*/;

export default function sanitizeUserMessage(message?: unknown): string {
  if (message == null) {
    return '';
  }

  const normalizedMessage = String(message).trim();
  if (!normalizedMessage) {
    return '';
  }

  return normalizedMessage.replace(COMPONENT_PREFIX_PATTERN, '').trim();
}
